/** Created by azhou on 2019/2/14.*/
<template>
  <div>
    <div class="d-flex">
      <div class="w-100" :class="{'info-wrap':!isEdit}" >
        <el-radio-group v-model="tabPosition" class="tab-position" v-if="!isEdit&&!isAdmin">
          <el-radio-button label="1">基本信息</el-radio-button>
          <el-radio-button label="2">设施标签</el-radio-button>
          <el-radio-button label="3">团队政策</el-radio-button>
        </el-radio-group>
        <div>

        </div>
        <div v-show="tabPosition==1" class="p-2">
          <div v-if="!$route.path.includes('info-manage') || userLoginMessage.type == 99">
            <left-text-border class="mb-2"
                v-if="step==1"
                v-model="BasicInfo.title"
                :leftText="'酒店名称'"
                :placeholder="BasicInfo.title ? BasicInfo.title :'请输入酒店名称'"
                :disabled="disabledStoreName"
                @blur="onTextareaBlur"
                required
                />
          <left-text-border class="mb-2"
                inputId="inputTitle"
                v-else
                v-model="BasicInfo.title"
                :leftText="'酒店名称'"
                :placeholder="BasicInfo.title ? BasicInfo.title :'请输入酒店名称'"
                :disabled="disabledStoreName"
                 @blur="onTextareaBlur"
                required
                />
            <div v-if="existence" class="existence">该酒店名称已存在请更换酒店名称</div>
            <select-city class="mb-2"
                        leftText="省市区"
                        required
                        @getCityInfo="getCityInfo"
                        :provinceId="BasicInfo.province*1"
                        :cityId="BasicInfo.city*1"
                        :districtId="BasicInfo.district*1"/>
            <left-text-border class="mb-3"
                              leftText="详细地址"
                              placeholder="请输入详细地址"
                              v-model="BasicInfo.address"
                              required
                              @blur="checkAddress"
                              />
            <!-- <left-text-radio class="mb-1"
                              :options="$GVAR.HotelStar.slice(2,7)"
                              placeholder="请选择星级"
                              v-if="storeInfo.type==3&&!isEdit"
                              v-model="BasicInfo.star"
                              required
                              leftText="酒店星级"/> -->
          </div>
          <div class="existence" v-if="checkAddressCount>0">当前地址存在{{checkAddressCount}}个门店  
            <el-popover
              placement="right"
              width="450"
              trigger="click">
              <el-table :data="checkAddressList" >
                <el-table-column width="200" property="title" label="酒店名称"></el-table-column>
                <el-table-column width="150" property="time" label="注册时间" align="center">
                  <template slot-scope="scope">
                    {{scope.row.time | formatTimestamp(1)}}
                  </template>
                </el-table-column>
                <el-table-column width="100" property="create_name" label="注册人" align="center"></el-table-column>
              </el-table>
              <el-button class="ml-2" size="mini" slot="reference">查看</el-button>
            </el-popover>
          </div>
          <div class="mb-2" :class="{'d-center':!isEdit}">
            <left-text-border class="w-50 mb-2 mr-4"
                              v-if="!isEdit"
                              leftText="开业时间"
                              v-model="BasicInfo.startdate"
                              placeholder="选择日期"
                              :inputWidth="600"
                              type="month"
                              />     

            <left-text-border class="w-50 mb-3 ml-4"
                              leftText="最近装修"
                              v-if="!isEdit"
                              v-model="BasicInfo.fitmentdate"
                              placeholder="选择日期"
                               type="month"
                              />                                                       
          </div>
          <div class="mb-2" :class="{}">
            <left-text-border-many class="w-50 mb-3 mr-4"
                              :leftText="'前台/总机'"
                              v-model.trim="BasicInfo.store_tel"
                              placeholder="例如：0571-123456"
                              :inputWidth="283"
                              required
                              />            
          </div>
            <div class=" mb-2" >
            <!-- <left-text-border class="w-50 mb-2 mr-4"
                              leftText="联系人"
                              v-model="BasicInfo.contact"
                              placeholder="请填写联系人姓名"
                              required/> -->
            <left-text-border class="w-50 mb-3 mr-4"
                              leftText="传真"
                              :inputWidth="245"
                              v-model="BasicInfo.hotel_fax"
                              placeholder="请填写传真"
                              />
          </div>
          <!-- <div class="  mb-2">
            <left-text-radio class="  mb-1  "
                              leftText="早餐类型"
                              v-if="!isEdit"
                              :options="$GVAR.breakfastTypeArr.slice(0,4)"
                              v-model.trim="BasicInfo.breakfast_type"
                              placeholder=""
                              />                            
          </div> -->
          <div class="d-start-start mb-3">
            <left-text leftText="早餐类型" required/>
            <el-checkbox-group v-model="BasicInfo.breakfast_type" class="d-center-start flex-wrap" @change="changeBreakfastType"> 
              <el-checkbox :label="item.id" :key="item.name" class="mr-3 ml-0"
                          v-for="item in $GVAR.breakfastHotel">{{item.name}}  
              </el-checkbox>
            </el-checkbox-group>
          </div>
          <div class=" mb-2" v-if="targets(['1','2'])">
            <left-text-timespan class="w-50 mb-2 mr-4"
                              :leftText="'早餐时间'"
                              v-if="!isEdit"
                              v-model="BasicInfo.breakfast_time"
                              placeholder=""
                               type="daterange"
                              />                                  
          </div>
          <left-text-multiple-choice class="mb-3" leftText="酒店设施"  v-model="BasicInfo.facility" :options="$GVAR.FacilitiesBasic" :formatVar="'FacilitiesBasic'" v-if="!isAdmin"/>
          <left-text-multiple-choice class="mb-3" leftText="酒店服务"  v-model="BasicInfo.service" :options="$GVAR.Facilitiesflsec" :formatVar="'Facilitiesflsec'"  v-if="!isAdmin"/>
          <left-text-border class="w-100 mb-3 mr-4"
                :leftText="'酒店简介'"
                v-if="!isEdit"
                v-model="BasicInfo.intro"
                type="textarea"
                placeholder="请输入酒店简介信息"
          />
          <!--携程酒店ID-->
          <left-text-border class="w-50 mb-2 mr-4"
                  leftText="携程酒店ID"
                  :inputWidth="245"
                  v-model="BasicInfo.c_hotel_id "
                  placeholder="请填写携程酒店ID"
          />  
          <!-- <left-text-checkbox 
            class="mb-3"
              leftText="酒店设施"                   
              v-model="BasicInfo.facility"
              :options="$GVAR.FacilitiesBasic"
              @blur="(content)=>{this.addressDetail = content;}"
          /> -->
          <!-- <left-text-checkbox 
            class="mb-3"
              leftText="酒店服务"                   
              v-model="BasicInfo.service"
              :options="$GVAR.Facilitiesflsec"
              @blur="(content)=>{this.addressDetail = content;}"
          /> -->
          <div class="d-start-start mb-3" v-if="storeInfo.type===6">
            <left-text leftText="景点星级" required/>
            <el-radio-group v-model="BasicInfo.star" class="d-center-start flex-wrap mt-1">
              <el-radio :label="item.id" :key="item.name" class="mr-3 ml-0"
                        v-for="item in $GVAR.scenicStarArr.slice(0,6)">{{item.name}}
              </el-radio>
            </el-radio-group>
          </div>
          <div class="d-start-start mb-3" v-if="storeInfo.type==6">
            <left-text leftText="景点主题" required/>
            <el-checkbox-group v-model="BasicInfo.theme" class="d-center-start flex-wrap">
              <el-checkbox :label="item.id" :key="item.name" class="mr-3 ml-0"
                          v-for="item in $GVAR.scenicThemeArr">{{item.name}}
              </el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
        <div v-show="tabPosition==2" class="mt-1 p-2">
            <div class="starRating">
              <p :class="{'classify':!state_star}"  @click="tabstate_star(false)">平台星级</p>
              <p :class="{'classify':state_star}" @click="tabstate_star(true)">评星酒店</p>
            </div>
            <left-text-radio class="mb-1"
                              :options="state_star? $GVAR.governmentHotelStar:$GVAR.HotelStar.slice(2,7)"
                              placeholder="请选择星级"
                              v-if="storeInfo.type==3&&!isEdit"
                              v-model="BasicInfo.star"
                              required
                              leftText="酒店星级"
                              :radio="true"
                              />
            <left-text-radio class="mb-3"
                              leftText="住宿类型"                   
                              v-model="BasicInfo.type"
                              :options="$GVAR.StyleLabel"
                              :radio="true"
                              />
            <left-text-radio class="mb-3"
                              leftText="装修风格"                   
                              v-model="BasicInfo.decorate "
                              :options="$GVAR.DecorationLabel"
                              :radio="true"
                              />
          <left-text-checkbox class="mb-3"
                                leftText="主题特色"                   
                                v-model="BasicInfo.topic"
                                :options="$GVAR.SubjectType"
                                :checkbox="true"
                              />
            <left-text-brand class="mb-3"
                              leftText="酒店品牌"                   
                              v-model="BasicInfo.brand"
                              :options="$GVAR.FacilitiesPlatform"
                              />
        </div>
        <div v-show="tabPosition==3" class="mt-1 p-2">
          <div>
            <left-text-radio class="mb-3"
                              leftText="酒店资质"                   
                              v-model="BasicInfo.recepte"
                              :options="$GVAR.receptionAccess"
                              @blur="(content)=>{this.addressDetail = content;}"
                              />
            <left-text-radio2 class="mb-2"
                              leftText="司陪政策"        
                              v-if="!isEdit"           
                              v-model="BasicInfo.escort_policy"
                              :options="$GVAR.escortPolicyArr"
                              @blur="(content)=>{this.addressDetail = content;}"
                              />
            <left-text-radio class="mb-2"
                              leftText="最低成团"                   
                              v-model="BasicInfo.min_team_num"
                              :options="$GVAR.minTeamNumArr"
                              @blur="(content)=>{this.addressDetail = content;}"
                              />
            <left-text-unit class="mb-2"
                              leftText="客房总数"                   
                              v-model="BasicInfo.room_count"
                              unit="间"
                              required
                              />
           <left-text-unit class="mb-2"
                              leftText="双床房总数量"                   
                              v-model="BasicInfo.room_2_count"
                              unit="间"
                              required
                              />
            <left-text-unit class="mb-2"
                              leftText="会议室数量"                   
                              v-model="BasicInfo.meeting_count"
                              unit="个"
                              @blur="(content)=>{this.addressDetail = content;}"
                              />
            <left-text-unit class="mb-2"
                              leftText="最大会议室面积"                   
                              v-model="BasicInfo.meeting_area"
                              unit="m"
                              @blur="(content)=>{this.addressDetail = content;}"
                              >
                              <span style="margin-right: -4px;">m<sup>2</sup></span>
                              </left-text-unit>
            <left-text-radio2 class="mb-2"
                              leftText="团队停车"                   
                              v-model="BasicInfo.parking"
                              :options="$GVAR.parkingArr"
                              @blur="(content)=>{this.addressDetail = content}"
                              />
          </div> 
        </div> 
      </div>
      <!--这里不允许拖拽maker，因为拖拽以后maker经纬度更新并能成功保存到后台
      但是页面上仍然是根据左侧的省市区和详细地址推算出来的大致位置-->
      <div v-if="!$route.path.includes('info-manage')" class="w-50">
        <!--              suggestId="inputTitle"-->
        <b-map class="w-100 ml-2"
              eleHeight="400"
              @setAddToPoint="point => this.lonLatInfo = point"
              @setStoreTitle="(v)=>this.BasicInfo.title = v"
              @dragMarker="position"
              :WheelZoom="true"
              :allowDrag="true"
              :markPoint="storePoint"
              :MapArea="MapArea"/>
        <div class="lies">
          <span class="text-danger">*</span>
            地图选点:
            <p>(经度)
              <span class="text-blue">{{BasicInfo.longitude||longitude}}</span>
            </p>
            <p>(纬度)
              <span class="text-blue">{{BasicInfo.latitude||latitude}}</span>
            </p>
          </div>
      </div>
    </div>
    <el-button @click="submitForm" class="mt-4 w-25 btn-login">保存信息</el-button>
  </div>
</template>

<script>
  import { mapState, mapGetters,mapActions} from 'vuex'
  import { UploadImages } from '@/assets/utils/uploadFiles'
  import BMap from '../../../../components/BMap/BMap'

  export default {
    name: 'HRegBasic',
    components: { BMap },
    computed: {
      ...mapState(['StoreBasicInfo','userLoginMessage']),
      ...mapGetters(['storeInfo','userInfo','isGroup','isAdmin']),
      //禁用修改门店名称
      disabledStoreName() {
        return this.userInfo.type !== 99 && this.StoreBasicInfo.verify === 1 && !this.$route.path.includes('basic') && !this.isGroup;
      },
      //当用户为单门店且在注册步骤时才显示上传营业执照,集团用户添加门店时才显示
      showCertpic() {
        if (this.isGroup) {
          return true;
        } else return this.StoreBasicInfo.verify !== 1;
      },
      storePoint () {
        return [{
            lng: this.BasicInfo.longitude > 0 ? this.BasicInfo.longitude : 120.206194,
            lat: this.BasicInfo.latitude > 0 ? this.BasicInfo.latitude : 30.291275,
            IconPng: require('../../../../../public/images/public/icon.png'),
            nid:true
          }]
      },
      storeSpecial () {          //不同身份门店电话名称不同
        switch (this.storeInfo.type) {
          case 3:return { cn: '酒店', storeTel: '总机电话' }
          case 5:return { cn: '民宿', storeTel: '总机电话' }
          case 6:return { cn: '景区', storeTel: '总机电话' }
          case 8:return { cn: '品牌馆', storeTel: '总机电话' }
          default:return ''
        }
      },
      MapArea () {     //传入给BMap组件的区域地址信息
        console.log(this.BasicInfo)
        return {
          province: this.BasicInfo.province_name,
          city: this.BasicInfo.city_name||'',
          district: this.BasicInfo.district_name||'',
          address: this.BasicInfo.address||''
        }
      },
      add () {
        return this.$route.query.add
      },
      step () {
        return this.$route.query.step
      },
      isEdit(){
        return this.$route.path.includes('info-manage')
      }
    },
    data () {
      return {
        BasicInfo: {
          address:'',
          title:"",
          star:0,
          breakfast_type:[],
          meetingAndBreakfast:[],
          fitmentdate:'',
          startdate:'',
          is_meeting:0,
          is_breakfast:0,
          room_count:'',
          room_2_count:'',
          breakfast_time:'07:00,09:00',
          store_tel:[],
        },
        addressDetail: '',
        certpic: '',            //base64格式营业执照，还未上传时不挂载到BasicInfo中
        lonLatInfo:{},          //门店经纬度信息，BMap组件不直接修改BasicInfo中的经纬度值，会引起重复渲染maker标记点
        name: false,
        tabPosition:1,
        longitude: 0,                        //经度
        latitude: 0,                         //纬度
        state_star :false,                   //政府星级
        existence:false,                     //酒店名称是否存在
        c_hotel_id:'',                       //携程酒店ID
        dialogVisible:true,                 //存在地址弹窗是否显示
        checkAddressCount:0,                 //检查地址是否存在多个门店
        checkAddressList:[],                 //检查地址是否存在多个门店列表
      }
    },
    watch: {
      StoreBasicInfo () {
        this.initStoreInfo()
      },
      add () {
        this.initStoreInfo()  
      }
    },
    created () {
      this.initStoreInfo()
    },
    methods: {
      ...mapActions(['POST_checkStoreTitle','POST_Admin_SearchHotelAddress']),
      /*失去焦点-判断酒店名称是否存在*/
      async onTextareaBlur(e){
        let title=this.BasicInfo.title.trim();// 获取输入关键词（去除首尾空格);
        if (!title) return; // 如果输入为空，不执行后续操作
        let data={
          title:title,
          type:3,
          page:1,
          num:10,
        }
        let result = await this.POST_checkStoreTitle(data);
        this.existence=result.list.some((item) => {
          return item.title === title;
        })
      },  
       //选择早餐类型
      changeBreakfastType(val){
        const targetUser = val.find(user => user == 4);
        //点击无早只保留无早选项/点击其他删除无早
        if(targetUser&&val[val.length-1]=='4'){
          this.BasicInfo.breakfast_type=['4']
        }else{
            const index = val.indexOf('4');
            if (index !== -1) { // 确保元素存在
              this.BasicInfo.breakfast_type.splice(index, 1); // 原地修改，触发响应式更新
            }
        }
      },
      tabstate_star(e){
        if(this.state_star==e) return;
        this._confirm(e?'是否切换成评星酒店':'是否切换成平台星级'+'?',() => {
          this.state_star = !this.state_star;
          this.BasicInfo.star='';
        })
      },
      /*初始化整理门店基本信息*/
      position(e){
        this.lonLatInfo= e;
        this.longitude = e.lng; this.latitude = e.lat;
        // this.BasicInfo.longitude=e.lng;
        // this.BasicInfo.latitude=e.lat;
        this.storePoint[0].nid=false;
      },
      initStoreInfo () {
        this.BasicInfo = {...this.BasicInfo,...this.StoreBasicInfo};
        this.BasicInfo.breakfast_type=this.BasicInfo.breakfast_type.length>0?this.$verify.stitch(this.BasicInfo.breakfast_type):[];
        this.BasicInfo.meetingAndBreakfast=[];
        if (this.storeInfo.type == 6 && (!this.BasicInfo.hasOwnProperty('star') || !this.BasicInfo.hasOwnProperty('theme'))) this.BasicInfo = {star: '', theme: []}
        this.certpic = this.BasicInfo.certpic || '';
        this.addressDetail = this.BasicInfo.address;
        //当景区star为其他时，后台会传回来一个数字0，只有当star为''时，才是未设置
        if (this.BasicInfo.star || this.BasicInfo.hasOwnProperty('star')) this.BasicInfo.star = this.BasicInfo.star + '';
        if (this.storeInfo.type == 3 && this.BasicInfo.star == 0) this.BasicInfo.star = '0'
        if(this.BasicInfo.is_meeting!=0){
          this.BasicInfo.meetingAndBreakfast.push('有会议')
        }
        if(this.BasicInfo.is_breakfast!=0){
          this.BasicInfo.meetingAndBreakfast.push('有餐饮')
        }
        if(this.BasicInfo.startdate!=0&&this.BasicInfo.startdate){      
          this.BasicInfo.startdate = this.BasicInfo.startdate.length==10?this.BasicInfo.startdate*1000:this.BasicInfo.startdate
        }else{
          this.BasicInfo.startdate =''
        }
        if(this.BasicInfo.fitmentdate!=0&&this.BasicInfo.fitmentdate){         
          this.BasicInfo.fitmentdate = this.BasicInfo.fitmentdate.length==10?this.BasicInfo.fitmentdate*1000:this.BasicInfo.fitmentdate
        }else{
          this.BasicInfo.fitmentdate = ''
        }
        switch (this.storeInfo.type) {
          case 3:this.BasicInfo.store_tel = this.BasicInfo.hotel_tel; break
          case 5:this.BasicInfo.store_tel = this.BasicInfo.homestay_tel; break
          case 6:
            this.BasicInfo.store_tel = this.BasicInfo.viewpoint_fax;
            if (!$.isArray(this.BasicInfo.theme)) this.BasicInfo.theme = this.BasicInfo.theme.split(',')
            break
          case 8:
            this.BasicInfo.store_tel = this.BasicInfo.brand_hall_fax
            this.BasicInfo.tel = this.BasicInfo.brand_hall_tel
            break
        }
        //如果是政府星级则赋值给state_star/
        if(this.BasicInfo.state_star){
          this.state_star=true;
          //如果是白金酒店则赋值star为6
          if(this.BasicInfo.state_star=='6'){
            this.BasicInfo.star='6';
          }
        }
        let lonLatInfo={
          lng:this.BasicInfo.longitude,
          lat:this.BasicInfo.latitude
        }
        this.position(lonLatInfo)
      },
      /*获取省市区id和name*/
      getCityInfo (info) {
        for (let key in info) {
          this.$set(this.BasicInfo,key,info[key]);
        }
        //调用检查地址是否存在多个门店方法
        if(info.district&&this.BasicInfo.address!=''){
            this.checkAddress();
        }
      },
      //判断首字是否是汉字
      isFirstCharChinese(str) {
      // 先校验输入：非字符串或空字符串直接返回 false
        if (typeof str !== 'string' || str.length === 0) return false;
        // 正则匹配首字符是否为汉字（Unicode 常用汉字范围：0x4E00-0x9FA5）
        const reg = /^[\u4E00-\u9FA5]/;
        return reg.test(str);
      },
      /*验证门店基本信息填写是否正确*/
      validateForm () {
        let i = this.BasicInfo;
        if (!i.title) return { code: false, msg: '请填写门店名称' }
        if(i.title.length<4) return { code: false, msg: '门店名不能少于4个字符' }
        // if(!this.isFirstCharChinese(i.title))return { code: false, msg: '首个字符必须是汉字' }
        if (!i.province || !i.city || !i.district) return { code: false, msg: '请选择门店省市区' }
        if (!i.address) return { code: false, msg: '请填写门店详细地址' }
        // if (!this.$GFUN.isFixTel(i.tel)) return { code: false, msg: '请填写正确办公电话' }
        switch (this.storeInfo.type) {
          case 3:
            if (!i.star&&this.tabPosition==2||i.star <= 0&&this.tabPosition==2) return { code: false, msg: '请选择酒店星级' };
            if (this.longitude==0 || this.latitude==0) return {code: false, msg: '经纬度定位有误，请检查地图标注位置是否正确'};
            if (this.tabPosition==3&&i.room_count<=0) return { code: false, msg: '请填写客房数量' }; 
            if (this.tabPosition==3&&i.room_2_count<=0) return { code: false, msg: '请填写双床房数量' }; 
            break;
          case 6:
            //if (!this.$GFUN.isName(i.contact)) return { code: false, msg: '请填写正确的联系人姓名' }
            //if (!i.mob) return { code: false, msg: '请填写联系电话' }
            if (i.theme.length <= 0) return { code: false, msg: '请设置景区主题' }; break;
          case 8: if (i.topic.length <= 0) return { code: false, msg: '请设置品牌馆主题' }
        }
        //验证多个前台电话
        let store_tel=[];
        if(i.store_tel.toString().indexOf(',')==-1){store_tel.push(i.store_tel)}else{store_tel=i.store_tel.split(',')}
        for(let i in store_tel){
           if (!this.$GFUN.isFixTel(store_tel[i])) return { code: false, msg: '请填写正确的前台/总机电话' }
        }
        console.log(i.breakfast_type,2);
        if (i.breakfast_type.length == 0) return { code: false, msg: '请选择早餐类型' };
        // if (this.certpic==''&&this.storeInfo.type==3) return { code: false, msg: '请上传营业执照' };
        return { code: true, msg: '表单验证通过' }
      },
     // 自定义判断：检查 date 中是否存在与目标 id 匹配的对象
      targets(date){
        const hasAll = date.some(item => this.BasicInfo.breakfast_type.includes(item));
        return hasAll
      },
      //检查地址是否存在多个门店
      checkAddress(){
        if(this.BasicInfo.district&&this.BasicInfo.address!=''&&this.isAdmin){
          this.POST_Admin_SearchHotelAddress({
            data:{
              province:this.BasicInfo.province,
              city:this.BasicInfo.city, 
              district:this.BasicInfo.district,
              address:this.BasicInfo.address,
            },
            successFun:(res)=>{
              this.checkAddressCount=res.count;
              res.list.forEach(item=>{
                item.create_name=item.create_name||'无';
              })
              this.checkAddressList=res.list;
              console.log(res);
            }
          })
          console.log('检测');
        }
      },
      /*保存门店基本信息*/
      async submitForm () {
        // 品牌馆权限
        if (this.existence) { this._alert('酒店名称已存在请更换名称！',null,'error'); return; }
        let result = this.validateForm()
        if (result.code) {
          this._confirm('确定保存信息么？', async () => {
            let data = {...this.BasicInfo}
            //处理基本信息中的营业执照
            data.certpic = (await UploadImages(this.certpic))[0];
            data.longitude = this.lonLatInfo.lng;
            data.latitude = this.lonLatInfo.lat;
            data.breakfast_type=data.breakfast_type.join(',');
            // 酒店：  hotel_tel
            // 民宿：  homestay_tel
            // 品牌馆： brand_hall_tel
            // 景区：  viewpoint_tel
            // 采购商总机： travel_tel
            switch (this.storeInfo.type) {
              case 2:
                data.travel_tel = data.store_tel;
                break;
              case 3:
                data.hotel_tel = data.store_tel;
                //如果是政府星级则赋值给state_star
                if(this.state_star){
                  data.state_star=data.star;
                  //如果是政府星级白金starid变为5
                  data.star=data.star=='6'?'5':data.star;
                }else{
                  data.state_star='';
                }
                //delete this.BasicInfo.store_tel;
                break;
              case 5:
                data.homestay_tel = data.store_tel;
                //delete this.BasicInfo.store_tel;
                break;
              case 6:
                data.viewpoint_fax = data.store_tel;
                data.viewpoint_tel = data.store_tel;
                data.theme = data.theme.join(',');
                //delete this.BasicInfo.store_tel;
                break;
              case 8:
                data.brand_hall_fax = data.store_tel
                data.brand_hall_tel = data.tel
            }
            data.meetingAndBreakfast=data.meetingAndBreakfast||[];
            if(data.meetingAndBreakfast){
              data.meetingAndBreakfast.indexOf('有会议')>-1?data.is_meeting=1:data.is_meeting=0
              data.meetingAndBreakfast.indexOf('有餐饮')>-1?data.is_breakfast=1:data.is_breakfast=0
            }
            if(data.startdate!=''){
              data.startdate = data.startdate/1000;
            }
            if(data.fitmentdate!=''){
              data.fitmentdate = data.fitmentdate/1000
            }

            // if(this.BasicInfo.type_label instanceof Array){
            //   // this.BasicInfo.type_label  = this.BasicInfo.type_label .join(',')
            //   this.$set(this.BasicInfo,'type_label',this.BasicInfo.type_label .join(','))
            // }
          delete data.meetingAndBreakfast; //删除多余字段
          if(!this.isEdit&&!this.isAdmin){
            data.tabPosition=this.tabPosition;
            this.$emit('saveInfo',data,++this.tabPosition) 
          }else{
            this.$emit('saveInfo', data)
          }
          })
        } else {
          this._alert(result.msg, null, 'error')
        }
      },
      //清空门店填写信息
      clearInfo(){
        let BasicInfo={
          address:'',
          title:"",
          star:0,
          breakfast_type:[],
          meetingAndBreakfast:[],
          fitmentdate:'',
          startdate:'',
          is_meeting:0,
          is_breakfast:0,
          room_count:'',
          room_2_count:'',
          breakfast_time:'07:00,09:00',
          store_tel:[],
        }
        this.BasicInfo=JSON.parse(JSON.stringify(BasicInfo));
      }
    }
  }
</script>

<style lang="scss" scoped>
  .existence{
      color: red;
      padding-bottom: 1rem;
      text-align: left;
      font-size: 12px;
      text-indent: 10em;
  }
.info-wrap{
  border: 1px var(--smtc-color-primary) solid;
  ::v-deep .el-radio-button__inner{
    padding: 18px 20px 20px;
    border-radius: 0px!important;
  }

  // ::v-deep .input-self-border input{
  //   width:95%;
  // }

  // ::v-deep  .el-radio-group{
  //   margin-top: -2px;
  //   width: 100%;
  //   text-align: left;
  // }
  ::v-deep .input-self-border{
    display: flex;
  }
  
}
.lies{
  margin-top: 10px;
  text-align: center;
}
.lies p{
  margin-top: 10px;
}
.tab-position{
  margin-bottom: 20px;
  width: 100%;
  text-align: left;
}
.starRating{
  text-align: left;
  display: flex;
  text-align: center;
  margin-bottom: 10px;
  border-radius: 4px;
  overflow: hidden;
  width: 180px;
  line-height: 30px;
  border: 1px #eee solid;
  font-size: 12px;
  margin-top: -10px;
  margin-bottom: 15px;
}
.starRating p {
  width: 100px;
  cursor: pointer;
}
.classify{
  background-color: var(--smtc-color-primary);
  color: #fff;
}
.btn-login{
  margin: 0 auto;
  display: block;
}
</style>